module.exports = __webpack_public_path__ + "static/media/logo.a46b1223.svg";